/**
 * Handles triggering, and responding to events for the assetselector.
 * Allows showing and hiding the asset selector with messages.
 *
 * @author Dan Pomeroy (dp@yext.com)
 */
goog.provide('yext.dam.assetselector.events');

yext.dam.assetselector.events.showSelector = 'show.assetselector';
yext.dam.assetselector.events.closeSelector = 'close.assetselector';
yext.dam.assetselector.events.resetTitleSelector = 'resetTitle.assetselector';

// Methods for showing and hiding the asset selector with messages, rather than direct calls
/**
 * Asynchronously calls the normal show method
 * @see yext.dam.assetselector.show
 */
yext.dam.assetselector.events.show = (...args) => {
  if (args.length===0) return;
  $(yext.dam.assetselector.events).trigger(yext.dam.assetselector.events.showSelector, args);
};
yext.dam.assetselector.events.close = () => $(yext.dam.assetselector.events).trigger(yext.dam.assetselector.events.closeSelector);
yext.dam.assetselector.events.resetTitle = () => $(yext.dam.assetselector.events).trigger(yext.dam.assetselector.events.resetTitleSelector);

goog.exportSymbol('yext.dam.assetselector.events', yext.dam.assetselector.events);
